import { Component, OnInit } from '@angular/core';
import { OrderFilterModel, OrderModel, OrderServiceProxy, OrderStatus } from '../../../../shared/service-proxies/event-service-proxy';
import { TableColumn } from '../../../interfaces/table-column.interface';
import { FilterService } from '../../../services/filter/filter.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DestroyService } from '../../../services/destroy/destroy.service';
import { takeUntil } from 'rxjs';
import { ErrorService } from '../../../services/error/error.service';
import { ToastrService } from '../../../services/toastr/toastr.service';

@Component({
    selector: 'app-order-list-page',
    templateUrl: './order-list-page.component.html',
    styleUrl: './order-list-page.component.scss',
    providers: [DestroyService],
    standalone: false
})
export class OrderListPageComponent implements OnInit {
  public orderFilter: OrderFilterModel = new OrderFilterModel();
  public orders: OrderModel[] = [];

  public columns: TableColumn[] = [
    { header: 'Заказ', field: 'code', col: 5 },
    { header: 'Сумма', field: 'total', col: 5 },
    { header: 'Создан', field: 'createdAt', col: 5 },
    { header: 'Пользователь', fields: ['user.firstname', 'user.lastname'], col: 5 },
    { header: '', field: 'status', col: 4, isPagination: true },
  ];

  activeFilter: boolean = false;
  dataMissing: boolean|string = false;

  isLoading: boolean = true;

  currentPage: number = 1;
  pageSize: number = 15;
  totalItems: number = 0;

  constructor(private route: ActivatedRoute, private toastrService: ToastrService, private errorService: ErrorService, private _orderService: OrderServiceProxy, private filterService: FilterService, private router: Router, private destroyService: DestroyService) {
  }

  ngOnInit(): void {
    this.getFilterState();
    this.getOrders();
   
  }

  ngAfterViewInit() {
    this.showToast();
  }

  showToast() {
    const success = localStorage.getItem('orderSuccess');
    if (success === 'true') {
      this.toastrService.showSuccessToastr('Заказ успешно создан! Он появился в списке заказов.');
      localStorage.removeItem('orderSuccess');
    }
  }

  getOrders() {
    this.orderFilter.page = this.currentPage;
    this.orderFilter.perPage = this.pageSize;
    console.log(this.orderFilter.users);
    
    this._orderService.getByFilter(this.orderFilter)
      .pipe(takeUntil(this.destroyService.onDestroy$))
      .subscribe((orders) => {
        this.orders = orders.items;
        this.totalItems = orders.total; 
        this.isLoading = false;
        if (this.orders.length == 0) this.dataMissing = true;
        console.log(orders);
    }, error => {
        console.error(error);
        this.isLoading = false;
        this.dataMissing = 'Не удалось получить список заказов. Попробуйте позже.';
        this.errorService.handleError(error, 'Не удалось получить список заказов. Попробуйте позже.');
    })
  }

  getFilterState() {
    const currentUrl = this.router.url;
    this.filterService.getFilterState(currentUrl)
      .pipe(takeUntil(this.destroyService.onDestroy$))
      .subscribe((state) => {
      this.activeFilter = state; 
    });
  }

  onPageChange(newPage: number): void {
    this.currentPage = newPage;
    this.getOrders();
  }

  onFilterApply(filter: OrderFilterModel): void {
    this.orderFilter = filter.clone();
    this.currentPage = 1; 
    this.getOrders();
  }
  
  onFilterReset(): void {
    this.orderFilter = new OrderFilterModel(); 
    this.currentPage = 1; 
    this.getOrders();
  }

  getOrderStatuses(status: OrderStatus): string {
    switch (status) {
      case OrderStatus.Draft:
        return "Черновик";
      case OrderStatus.New:
        return "Новый";
      case OrderStatus.Paid:
        return "Оплаченный";
      case OrderStatus.Processing:
        return "В обработке";  
      case OrderStatus.Completed:
        return "Завершенный";
      case OrderStatus.Cancelled:
        return "Отмененный";
      default:
        return "Неизвестный";
    }
  }


  onFilterChanged(updatedFilter: OrderFilterModel) {
    this.orderFilter = updatedFilter.clone();
    console.log('Оновлений фільтр:', this.orderFilter);
  }

}
